import { OrgTypes } from '@mode/shared/contract-common';
import { Map } from 'immutable';

import { createFlag, FeatureFlagStateType } from './feature-flag.state';

/**
 * Features
 *
 * Abstract UI webapp feature points that enumerates
 * the surface area of the webapp UI.  For example we map
 * {@link Features} to {@link FeatureFlagStateType} below
 * to generate a lookup table to query the {@link Features}'s
 * enabled state
 */
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Features {
  export enum Common {
    // Mode Business upsells throughout the product for "Free" users
    ModeBusinessUpsell = '[Common] ModeBusinessUpsell',
    // Mode for "Free" users
    ModeStudio = '[Common] ModeStudio',
    IntercomChat = '[Common] IntercomChat',
  }

  export enum Report {
    DrillDown = '[Report] DrillDown',
    Explore = '[Report] Explore',
    VizToolbar = '[Report] VizToolbar',
    ChartDataExport = '[Report] ChartDataExport',
    ParameterRunButton = '[Report] ParameterRunButton',
    Parameters = '[Report] Parameters',
  }
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace AppStateFeatures {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  export namespace Type {
    export enum SelectedReport {
      DrillDownsEnabled = '[Type] [SelectedReport] DrillDownsEnabled',
    }
  }

  export type Types = Type.SelectedReport;
}

/**
 * Feature Flag Map
 *
 * A static mapping of {@link FeatureFlagStateType}
 * by {@link Features}
 *
 * @type {Map<string, FeatureFlagStateType[]>}
 */
export const FEATURE_FLAG_MAP = Map<FeatureFlagStateType[]>({
  [Features.Report.DrillDown]: [
    createFlag({
      type: AppStateFeatures.Type.SelectedReport.DrillDownsEnabled,
      context: null,
    }),
  ],

  [Features.Report.Explore]: [
    createFlag({
      type: AppStateFeatures.Type.SelectedReport.DrillDownsEnabled,
      context: null,
    }),
  ],

  [Features.Report.VizToolbar]: [
    createFlag({
      type: AppStateFeatures.Type.SelectedReport.DrillDownsEnabled,
      context: null,
    }),
  ],

  [Features.Report.ChartDataExport]: [
    createFlag({
      type: OrgTypes.PlanCode.Plus,
      context: OrgTypes.PlanCodeContext.Report,
    }),
  ],

  [Features.Report.ParameterRunButton]: [
    createFlag({
      type: OrgTypes.PlanCode.Plus,
      context: OrgTypes.PlanCodeContext.Report,
    }),
  ],

  [Features.Report.Parameters]: [
    createFlag({
      type: OrgTypes.PlanCode.Plus,
      context: OrgTypes.PlanCodeContext.Report,
    }),
    createFlag({
      type: OrgTypes.PlanCode.Standard,
      context: OrgTypes.PlanCodeContext.Report,
    }),
  ],

  [Features.Common.ModeBusinessUpsell]: [
    createFlag({
      type: OrgTypes.PlanCode.Free,
      context: OrgTypes.PlanCodeContext.Report,
    }),
  ],

  [Features.Common.ModeStudio]: [
    createFlag({
      type: OrgTypes.PlanCode.Free,
      context: OrgTypes.PlanCodeContext.Report,
    }),
  ],

  [Features.Common.IntercomChat]: [
    createFlag({
      type: OrgTypes.PlanCode.Plus,
      context: OrgTypes.PlanCodeContext.Report,
    }),
    createFlag({
      type: OrgTypes.PlanCode.Standard,
      context: OrgTypes.PlanCodeContext.Report,
    }),
  ],
});
